import ICommit from '@/store/contracts/commit'

const getDefaultState = () => ({
        linguisticVariables: [],
        // initial reader variable
        initialReaderActive: false,
})

const CommonModule = {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        linguisticVariables: (state: any, value: any) => {
            state.linguisticVariables = value
        },
        setInitialReaderActive: (state: any, value: boolean) => state.initialReaderActive = value
    },
    actions: {
        setLinguisticVariables({ commit }: ICommit, value: any) {
            commit('linguisticVariables', value)
        },
        setInitialReaderActive({commit}: any, value: boolean) {
            commit("setInitialReaderActive", value)
        }
    },
}

export default CommonModule
